export default __webpack_public_path__ + "static/media/Mask.e0e07086.png";